// extracted by mini-css-extract-plugin
module.exports = {"form-wrapper":"AuthForm_form-wrapper__wDXcW","forgot-password-link":"AuthForm_forgot-password-link__hOPZp"};